<template>
  <div
    class="c-basket-number rounded-full w-6 h-6 flex justify-center items-center text-center bg-app-secondary-8-blue--medium-aquamarine leading-none font-mono font-semibold text-black"
  >
    <span>
      <slot />
    </span>
  </div>
</template>

<style lang="scss" scoped>
.c-basket-number {
  font-size: 11px; // custom size needed here to follow design of this little element, in this case it has to be this precise
}
</style>
